import { MutationOptions, useMutation } from "react-query";
import { APIError, APIResponse, API_URL, post } from "../api";

export interface Data {
  headers: Headers;
  original: Original;
  exception: any;
}

export interface Headers {}

export interface Original {
  code: string;
  status: boolean;
  message: string;
  data: Data2;
}

export interface Data2 {
  option: Option;
  option_data: OptionData;
  payment_data: PaymentData;
}

export interface Option {
  id: string;
  public_id: string;
  name: string;
  description: string;
  code: string;
  icon: any;
}

export interface OptionData {
  tag: string;
  options: Options;
}

export interface Options {
  name: string;
}

export interface PaymentData {
  amount: string;
  processing_fee: number;
  total_amount_payable: number;
  number_of_instalments: number;
  single_installment_amount: number;
  instalments: Instalment[];
  option_id: number;
  formatted: Formatted2;
  loan_id: string;
  // Flexible down payment (aviation parity). The customer may pay >= the minimum,
  // which shrinks the financed amount. `full_payoff` is true when the down payment
  // covers the whole order (no loan is created — complete via the instant path).
  down_payment?: number;
  minimum_down_payment?: number;
  down_payment_percent?: number;
  commission_fee?: number;
  interest_rate?: number;
  interest_months?: number;
  calculated_interest?: number;
  full_payoff?: boolean;
}

export interface Instalment {
  amount: number;
  processing_fee: number;
  total_amount_payable: number;
  due: string;
  formatted: Formatted;
}

export interface Formatted {
  amount: string;
  processing_fee: string;
  total_amount_payable: string;
}

export interface Formatted2 {
  amount: string;
  processing_fee: string;
  down_payment: string;
  minimum_down_payment?: string;
  single_installment_amount: string;
  total_amount_payable: string;
}

function useSelectPaymentOption(
  options?: MutationOptions<APIResponse<Data>, APIError, Record<any, any>>
) {
  const {
    mutate: selectPaymentOption,
    isLoading: selectingPaymentOption,
    isError: isSelectingPaymentOptionError,
    error: selectPaymentOptionError,
    data: paymentData,
  } = useMutation(async (variables) => {
    const token = localStorage.getItem("token");

    return await post(
      API_URL + "/commerce/cart/checkout/payment/select",
      variables,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
  }, options);

  return {
    paymentData,
    selectPaymentOption,
    selectingPaymentOption,
    isSelectingPaymentOptionError,
    selectPaymentOptionError,
  };
}

export default useSelectPaymentOption;
